import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";

import { ICrushSummary } from "../models/Vehicle";
import { DefaultResponseWithData } from "../models/system";

export default function useCrushSummary(vehicleId?: string) {
  const { get } = useApiHelper();

  const crushSummary = useQuery({
    queryKey: ["vehicles", vehicleId, "crush-summary"],
    queryFn: () => get<DefaultResponseWithData<ICrushSummary>>(`/vehicle/${vehicleId}/crush-summary`),
    enabled: !!vehicleId,
  });

  return {
    crushSummary,
  };
}
